var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStageProcess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#071A24",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10C12.8307 10 10.2353 12.4573 10.0151 15.5706L11.2929 14.2929C11.6834 13.9024 12.3166 13.9024 12.7071 14.2929C13.0976 14.6834 13.0976 15.3166 12.7071 15.7071L9.70709 18.7071C9.31657 19.0976 8.6834 19.0976 8.29288 18.7071L5.29289 15.7071C4.90237 15.3166 4.90237 14.6834 5.29289 14.2929C5.68342 13.9024 6.31658 13.9024 6.70711 14.2929L8.01003 15.5958C8.22053 11.3653 11.7173 8 16 8C18.2383 8 20.2634 8.92053 21.7142 10.4011C22.1008 10.7956 22.0944 11.4287 21.6999 11.8153C21.3054 12.2018 20.6723 12.1954 20.2858 11.8009C19.1956 10.6884 17.6791 10 16 10ZM25.2929 17.7071C25.6834 18.0976 26.3166 18.0976 26.7071 17.7071C27.0976 17.3166 27.0976 16.6834 26.7071 16.2929L23.7071 13.2929C23.3166 12.9024 22.6834 12.9024 22.2929 13.2929L19.2929 16.2929C18.9024 16.6834 18.9024 17.3166 19.2929 17.7071C19.6834 18.0976 20.3166 18.0976 20.7071 17.7071L21.9849 16.4293C21.7648 19.5426 19.1694 22 16.0001 22C14.3649 22 12.8842 21.3472 11.801 20.2858C11.4065 19.8992 10.7734 19.9056 10.3868 20.3001C10.0003 20.6946 10.0067 21.3277 10.4012 21.7142C11.8431 23.1272 13.8206 24 16.0001 24C20.2828 24 23.7795 20.6347 23.99 16.4042L25.2929 17.7071Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStageProcess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stage_process.f186be12858c12cdc2d2795ae3b5b8c1.svg";